var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"detail-button",attrs:{"to":this.link}},[_vm._v(" Detail ")])
}
var staticRenderFns = []

export { render, staticRenderFns }